module.exports = {
  colors: {
    primary: "#000000",
    secondary: "#AEE4FF",
    tertiary: "#F2F2F2",
    text: "#000000",
    background: "#ffffff",
  },
  breakpoints: {
    xs: "480px",
    sm: "768px",
    md: "992px",
    lg: "1200px",
  },
  fonts: {
    primary: "Roboto, Arial, sans-serif",
  },
  borderRadius: "1rem",
  pageWidth: "62.5rem",
  headerHeight: "6.25rem",
  footerHeight: "7.5rem",
}
